import defaultSettings from '@/libs/settingMer';
var title = defaultSettings.title;
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}